import { Injectable } from '@angular/core';

import { RoundFormatLabel } from '@core/models/brijjsports.enums';
import { ArrowValue, ScoringSession } from '@core/models/brijjsports.models';
import {
  archerTotalInSession,
  athleteIdsInSession,
  previousBestForAthlete,
  sessionSortKey,
  totalArrows
} from '@core/utils/scoring.util';

import { ScoringAdapter, SportDashboardTile } from '../sport.types';

/** Archery implementation of {@link ScoringAdapter}. */
@Injectable({ providedIn: 'root' })
export class ArcheryScoringAdapter implements ScoringAdapter {
  athleteTotalInSession(session: ScoringSession, athleteId: string): number {
    return archerTotalInSession(session, athleteId);
  }

  athleteIdsInSession(session: ScoringSession): string[] {
    return athleteIdsInSession(session);
  }

  sessionSortKey(session: ScoringSession): number {
    return new Date(sessionSortKey(session)).getTime();
  }

  sessionLabel(session: ScoringSession): string {
    if (session.name) return session.name;
    const firstRound = session.rounds?.[0];
    const fmt = firstRound ? RoundFormatLabel[firstRound.format] : 'Custom round';
    const arrows = totalArrows(session.rounds ?? []);
    return arrows ? `${fmt} · ${arrows} arrows` : fmt;
  }

  bestForAthlete(sessions: ScoringSession[], athleteId: string): number {
    return previousBestForAthlete(sessions, athleteId, 'archery');
  }

  statTiles(session: ScoringSession): SportDashboardTile[] {
    let tens = 0;
    let xs = 0;
    let arrows = 0;
    for (const score of session.scores ?? []) {
      for (const round of score.rounds) {
        for (const end of round.ends) {
          for (const arrow of end) {
            arrows++;
            if (this.isX(arrow)) xs++;
            else if (arrow === 10) tens++;
          }
        }
      }
    }
    return [
      { label: 'Arrows', value: arrows },
      { label: '10s', value: tens + xs, hint: 'Includes Xs' },
      { label: "X's", value: xs, hint: 'Inner-10 tiebreak' }
    ];
  }

  private isX(arrow: ArrowValue): boolean {
    return arrow === 'X';
  }
}
